import { Injectable } from "@angular/core";
import "firebase/firestore";
import { ToastrService } from "ngx-toastr";
import { AngularFireStorage } from "@angular/fire/compat/storage";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { Subject } from "rxjs";
import { BehaviorSubject } from "rxjs";
import { ApiService } from "../services/api.service";
// import { Storage } from "@ionic/storage";
import { Filesystem, Directory, Encoding } from "@capacitor/filesystem";
import { Capacitor } from "@capacitor/core";
import { Preferences } from "@capacitor/preferences";

@Injectable({
  providedIn: "root",
})
export class DownloadsService {
  downloads: Subject<any> = new BehaviorSubject<any>({});
  isDownloading = false;
  constructor(
    private afDb: AngularFirestore,
    private toaster: ToastrService,
    private storage: AngularFireStorage,
    // private localStorage: Storage,
    private api: ApiService
  ) {}

  updateDownloads(item) {
    this.downloads.next(item);
  }
  async download(key, url, title) {
    return new Promise(async (resolve, reject) => {
      const response = await fetch(url);
      const blob = await response.blob();
      const fileReader = new FileReader();
      const zoneOriginalInstance = (fileReader as any)["__zone_symbol__originalInstance"];
      const reader = zoneOriginalInstance || fileReader;
      reader.readAsDataURL(blob);
      reader.onloadend = async () => {
        const base64data = reader.result;
        try {
          // Usar Filesystem también en web para archivos grandes
          await Filesystem.writeFile({
            path: `pdsgiv/${key}/${title}`,
            data: base64data.toString(),
            directory: Directory.Data,
          });
          resolve({});
        } catch (e) {
          console.log("🚀 ~ file: downloads.service.ts:55 ~ DownloadsService ~ reader.onloadend= ~ e:", e)
          reject(e);
        }
      };
    });
  }
  async createDir(key) {
    return await Filesystem.mkdir({
      directory: Directory.Data,
      path: `pdsgiv/${key}`,
      recursive: true,
    });
  }
  async deleteDir(key) {
    return await Filesystem.rmdir({
      directory: Directory.Data,
      path: `pdsgiv/${key}`,
      recursive: true,
    });
  }

  async delete(key, pages) {
    return new Promise(async (resolve, reject) => {
      try {
        for (let i = 0; i <= pages; i++) {
          // Eliminar archivos usando Filesystem
          try {
            await Filesystem.deleteFile({
              path: `pdsgiv/${key}/${i}l.jpg`,
              directory: Directory.Data,
            });
            await Filesystem.deleteFile({
              path: `pdsgiv/${key}/${i}m.jpg`,
              directory: Directory.Data,
            });
            await Filesystem.deleteFile({
              path: `pdsgiv/${key}/${i}t.jpg`,
              directory: Directory.Data,
            });
          } catch (e) {
            // Ignorar errores si el archivo no existe
          }
        }
        resolve({});
      } catch (e) {
        reject(e);
      }
    });
  }
}
